import React, { useState } from "react";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

const ProductShowcaseCard = ({ product, onSubscribe }) => {
  const [selectedVariant, setSelectedVariant] = useState(
    product.variants?.[0] || null,
  );

  return (
    <div className="flex gap-2.5 overflow-hidden rounded-2xl border border-gray-100 bg-white p-2.5 shadow-sm transition hover:shadow-md sm:flex-col sm:gap-0 sm:p-0">
      {/* Product image */}
      <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-primary-50 to-blue-50 p-2 sm:h-40 sm:w-auto sm:rounded-none sm:p-3 sm:pb-1">
        {product.image ? (
          <img
            src={product.image}
            alt={product.name}
            className="h-full w-full object-contain drop-shadow-sm"
          />
        ) : (
          <Inventory2OutlinedIcon
            className="text-primary-200"
            style={{ fontSize: 44 }}
          />
        )}
      </div>

      <div className="flex min-w-0 flex-1 flex-col sm:p-3.5 sm:pt-2">
        <h3 className="mb-1.5 line-clamp-2 text-xs font-extrabold leading-snug text-gray-900 sm:mb-2.5 sm:text-sm">
          {product.name}
        </h3>

        {/* Variant chips */}
        {product.variants?.length > 0 && (
          <div className="mb-3 flex flex-wrap gap-1.5 sm:mb-4 sm:gap-2">
            {product.variants.map((variant) => {
              const isSelected =
                String(variant.product_variant_id) ===
                String(selectedVariant?.product_variant_id);
              return (
                <button
                  key={variant.product_variant_id}
                  type="button"
                  onClick={() => setSelectedVariant(variant)}
                  className={`rounded-lg border px-2 py-1.5 text-left transition sm:rounded-xl sm:px-3 sm:py-2 ${
                    isSelected
                      ? "border-primary-500 bg-primary-50 text-primary-700"
                      : "border-gray-200 bg-gray-50 text-gray-600 hover:border-primary-300"
                  }`}
                >
                  <p className="text-[11px] font-extrabold sm:text-xs">{variant.variant_name}</p>
                  <p className="mt-0.5 text-[10px] font-bold sm:text-[11px]">
                    Rs {Number(variant.discount_price || 0).toFixed(2)}
                    {Number(variant.original_price) > Number(variant.discount_price) && (
                      <span className="ml-1.5 font-semibold text-gray-400 line-through">
                        Rs {Number(variant.original_price).toFixed(2)}
                      </span>
                    )}
                  </p>
                </button>
              );
            })}
          </div>
        )}

        {/* Price summary for selected variant */}
        {selectedVariant && (
          <div className="mb-3 rounded-xl bg-gray-50 px-2.5 py-2 text-[11px] sm:mb-4 sm:px-3 sm:py-2.5 sm:text-xs">
            <div className="flex items-center justify-between">
              <span className="font-semibold text-gray-500">Per delivery</span>
              <span className="font-extrabold text-gray-900">
                Rs {Number(selectedVariant.discount_price || 0).toFixed(2)}
                {" / "}{selectedVariant.unit_name || "unit"}
              </span>
            </div>
            {Number(selectedVariant.original_price) > Number(selectedVariant.discount_price) && (
              <div className="mt-1 flex items-center justify-between">
                <span className="font-semibold text-emerald-600">You save</span>
                <span className="font-extrabold text-emerald-600">
                  Rs {(Number(selectedVariant.original_price) - Number(selectedVariant.discount_price)).toFixed(2)}
                </span>
              </div>
            )}
          </div>
        )}

        <button
          type="button"
          onClick={() =>
            onSubscribe(product.product_id, selectedVariant?.product_variant_id)
          }
          className="mt-auto flex w-full items-center justify-center gap-1.5 rounded-xl bg-primary-600 py-2.5 text-xs font-extrabold text-white shadow-sm shadow-primary-600/20 transition hover:bg-primary-700 active:scale-95 sm:gap-2 sm:text-sm"
        >
          <AddOutlinedIcon style={{ fontSize: 16 }} />
          Subscribe
        </button>
      </div>
    </div>
  );
};

export default ProductShowcaseCard;
